import React from 'react';
import { Row, Col, Badge } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import { stringify } from 'query-string';
import SVG from 'react-inlinesvg';
import Layout from '../../../../components/Layout/Layout';
import Card from '../../../../components/Card/Card';
import OffersListFilters from '../../components/Offers/OffersListFilters';
import Pagination from '../../../../components/Pagination/Pagination';
import LimitsList from '../../../../components/LimitsList/LimitsList';
import OfferRequestModal from '../../../../modals/OfferRequestModal/OfferRequestModal';
import OfferHasFlowsModal from '../../../../components/Offer/OfferHasFlowsModal';
import OfferRequestSuccessModal from '../../../../components/Offer/OfferRequestSuccessModal';
import { FMessage } from '../../../../hoc/IntlComponents';
import { STATIC_PATH } from '../../../../config';

export default class OffersPage extends React.Component {
  renderTabs = () => {
    const {
      data: { tabs },
    } = this.props;
    return !tabs
      ? []
      : this.props.data.tabs.map(({ prefix, title, count }) => {
          const { tab, page, sortOrder, sortBy, ...extraParams } = this.props.getParsedParams();
          return (
            <NavLink
              to={{
                pathname: `/offers/${prefix}`,
                search: `?${stringify({ ...extraParams, tab: prefix })}`,
              }}
              key={prefix}
              className={`nav-link nav-link--${prefix}`}
              isActive={() => this.props.data.tab === prefix}
              title={title}
              exact
            >
              {prefix === 'exclusive' && (
                <span className="isvg">
                  <SVG
                    src={`${STATIC_PATH}/img/offers/tabs/${prefix}.svg`}
                    width={16}
                    cacheRequests
                  />
                </span>
              )}
              <span className="offers-tabs-title">{title}</span>
              {count !== undefined ? (
                <Badge pill className="offers-count">
                  {count}
                </Badge>
              ) : null}
            </NavLink>
          );
        });
  };

  render() {
    const {
      renderRequestOfferButton,
      handleSearch,
      changePage,
      getActiveLimit,
      changeLimit,
      renderOffersList,
      offerRequestModalToggle,
      offerHasFlowsModalToggle,
      offerRequestSuccessModalToggle,
      data: {
        loading,
        page,
        limit,
        limits,
        offerRequestModalOpen,
        offerHasFlowsModalOpen,
        offerRequestSuccessModalOpen,
        mounted,
        selectedOffer,
        selectedOfferFlows,
        allowedOfferInfo,
      },
      pageCount,
      showAlert,
      sources,
      intl,
    } = this.props;

    return (
      <Layout formattedTitle="pages.offers.title">
        <Layout.Col>
          <Card className="offers-list-filters-card">
            <Card.Header titleLG={true}>
              <FMessage id="offers.filters.title.theme_4" />
            </Card.Header>
            <Card.Body>
              <OffersListFilters onSearch={handleSearch} />
            </Card.Body>
          </Card>
          <Card className="offers-list card-loading-silent" loading={loading}>
            <Card.HeaderNav
              navLinks={this.renderTabs()}
              innerRef={el => (this.cardHeaderRef = el)}
              controls={renderRequestOfferButton()}
              navClasses="col-lg-8 col-4"
              loading={loading}
            />

            <Card.Body className="no-padding">
              {mounted && (
                <Row className="controls-row">
                  <Col xl="8" lg="7" md="12">
                    {pageCount > 1 && (
                      <Pagination
                        affectUrl
                        pageCount={pageCount}
                        activePage={page + 1}
                        onPageChange={changePage}
                        scrollToAfterPageChanged={{
                          ref: this.cardHeaderRef,
                        }}
                      />
                    )}
                  </Col>

                  <Col xl="4" lg="5" md="12">
                    <LimitsList
                      activeLimit={getActiveLimit(limit)}
                      limits={limits}
                      onLimitChange={changeLimit}
                    />
                  </Col>
                </Row>
              )}
            </Card.Body>

            <Card.Body className="no-padding">
              <Row>
                <Col>{renderOffersList()}</Col>
              </Row>
            </Card.Body>

            {mounted && (
              <Card.Footer>
                <Row className="controls-row">
                  <Col xl="8" lg="7" md="12">
                    {pageCount > 1 && (
                      <Pagination
                        affectUrl
                        pageCount={pageCount}
                        activePage={page + 1}
                        onPageChange={changePage}
                        scrollToAfterPageChanged={{
                          ref: this.cardHeaderRef,
                        }}
                      />
                    )}
                  </Col>

                  <Col xl="4" lg="5" md="12">
                    <LimitsList
                      activeLimit={getActiveLimit(limit)}
                      limits={limits}
                      onLimitChange={changeLimit}
                      className="no-margin"
                    />
                  </Col>
                </Row>
              </Card.Footer>
            )}
          </Card>
        </Layout.Col>
        <OfferRequestModal
          open={offerRequestModalOpen}
          toggle={offerRequestModalToggle}
          showAlert={showAlert}
        />
        <OfferHasFlowsModal
          toggle={offerHasFlowsModalToggle}
          open={offerHasFlowsModalOpen}
          offerId={selectedOffer}
          flows={selectedOfferFlows}
        />
        <OfferRequestSuccessModal
          open={offerRequestSuccessModalOpen}
          toggle={offerRequestSuccessModalToggle}
          offer={allowedOfferInfo}
          sources={sources}
          intl={intl}
        />
      </Layout>
    );
  }
}
